import type { ButtonHTMLAttributes, Ref } from "react";
import React from "react";

/**
 * Base button component - Used to create clickable buttons with only base styling as default.
 * @param {ReactNode} children - Content to be rendered within the button. Can be a string or node.
 * @param {ButtonHTMLAttributes<HTMLButtonElement>} rest - Any other props to be passed to the button.
 */

interface ButtonBaseProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: Ref<HTMLButtonElement>;
}

function ButtonBase({ children, ref, ...rest }: ButtonBaseProps) {
  return (
    <button {...rest} ref={ref}>
      {children}
    </button>
  );
}

export default ButtonBase;
